import React from "react";
import { SEO } from "../../seo/SEO";
import styled from "styled-components";
import { useTypedResource } from "../../i18n/languagehandler";

const BOOK_URL =
  "https://hansreitzel.dk/products/barndom-i-det-bla-lys-bog-61334-9788702442311";

const Section = styled.section`
  max-width: 1100px;
  margin: 48px auto 80px;
  padding: 0 20px;
  display: grid;
  grid-template-columns: minmax(240px, 340px) 1fr;
  gap: 48px;
  align-items: start;

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
    gap: 28px;
  }
`;

const Cover = styled.img`
  width: 100%;
  height: auto;
  display: block;
  border-radius: 6px;
  box-shadow: 0 18px 40px rgba(31, 45, 61, 0.16);
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Title = styled.h2`
  color: var(--text);
  font-size: 40px;
  margin: 0 0 12px 0;
  line-height: 1.15;

  @media (max-width: 800px) {
    font-size: 32px;
  }
`;

const Subtitle = styled.p`
  color: var(--primary);
  font-size: 18px;
  font-weight: 500;
  line-height: 1.5;
  margin: 0 0 12px 0;
`;

const Authors = styled.p`
  color: var(--text);
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 24px 0;
`;

const OrderButton = styled.a`
  background: var(--primary);
  color: #fff;
  text-decoration: none;
  padding: 14px 26px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 16px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 28px 0;
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 8px 20px rgba(55, 90, 127, 0.22);

  &:hover {
    background: var(--primary-dark);
    transform: translateY(-2px);
    box-shadow: 0 12px 28px rgba(55, 90, 127, 0.3);
  }
`;

const Body = styled.p`
  color: var(--text-secondary);
  font-size: 17px;
  line-height: 1.7;
  margin: 0 0 18px 0;
`;

export const Books: React.FC = () => {
  const res = useTypedResource<{
    title: string;
    intro: string;
    authors: string;
    orderButton: string;
    paragraph1: string;
    paragraph2: string;
    paragraph3: string;
  }>("books");

  return (
    <main>
      <SEO
        title={res.title}
        description={res.intro}
        path="/books"
        image="/assets/Books/barndom-i-det-bla-lys.png"
      />
      <Section>
        <Cover
          src={process.env.PUBLIC_URL + "/assets/Books/barndom-i-det-bla-lys.png"}
          alt={res.title}
        />
        <Content>
          <Title>{res.title}</Title>
          <Subtitle>{res.intro}</Subtitle>
          <Authors>{res.authors}</Authors>
          <OrderButton href={BOOK_URL} target="_blank" rel="noopener noreferrer">
            {res.orderButton}
          </OrderButton>
          <Body>{res.paragraph1}</Body>
          <Body>{res.paragraph2}</Body>
          <Body>{res.paragraph3}</Body>
        </Content>
      </Section>
    </main>
  );
};
